import React from 'react';
import { breakpoints, color, font } from '../../styles/theme';
import { CmsMemory } from '../../integrations/contentful/types';
import Container from '../grid/Container';

import MemoryCard from '../memories/MemoryCard';
import { arrayHead } from '../../utils/array';

import { t } from '../../utils/i18n';
import Button from '../elements/Button';
import ButtonText from '../elements/ButtonText';
import { Paths } from '../../urls/Paths';

interface TripsGridProps {
  memories: CmsMemory[];
}

const TripsGrid: React.FC<TripsGridProps> = ({ memories = [] }) => {
  const displayMemories = memories.slice(0, 6);

  return (
    <div className="trips-section">
      <Container>
        <div className="section-header">
          <p className="section-label">{t('Suosituimmat')}</p>
          <h2 className="section-title">{t('Matkat')}</h2>
          <p className="section-subtitle">
            {t('Valitse sinulle sopiva golfmatka Viroon')}
          </p>
        </div>
        <div className="trips-grid">
          {displayMemories.map((cmsMemory, index) => {
            const {
              mainImage,
              slug,
              startDate,
              endDate,
              title,
              subtitle,
              matkanKesto,
              golfInfo,
              tripDepartures,
              vehicleInfo
            } = cmsMemory.fields;
            const traveller = arrayHead(cmsMemory.fields.travellers);

            if (!traveller) return null;

            return (
              <div key={pluginKey(index)} className="trip-card-wrapper">
                <MemoryCard
                  memory={{
                    mainImage,
                    slug,
                    startDate,
                    endDate,
                    title,
                    subtitle,
                    matkanKesto,
                    golfInfo,
                    tripDepartures,
                    vehicleInfo
                  }}
                  traveller={{
                    name: traveller.fields.title,
                    profilePicture: traveller.fields.profilePicture,
                    slug: traveller.fields.slug
                  }}
                />
              </div>
            );
          })}
        </div>
        <div className="cta-container">
          <Button onClick={() => (window.location.href = Paths.MemoryList)}>
            <ButtonText variant="primary" color="white">
              {t('Katso kaikki matkat')}
            </ButtonText>
          </Button>
        </div>
      </Container>
      {/*language=CSS*/}
      <style jsx>{`
        .trips-section {
          padding: 80px 0 100px;
          background-color: ${color.white};
        }

        .section-header {
          text-align: center;
          margin-bottom: 48px;
        }

        .section-label {
          font-family: ${font.primary};
          font-size: 0.8rem;
          font-weight: 600;
          letter-spacing: 0.2em;
          text-transform: uppercase;
          color: ${color.coral};
          margin: 0 0 8px;
        }

        .section-title {
          font-family: ${font.primary};
          font-size: 2.5rem;
          font-weight: 700;
          color: ${color.dark};
          margin: 0 0 12px;
        }

        .section-subtitle {
          font-family: ${font.primary};
          font-size: 1.1rem;
          color: ${color.gray};
          margin: 0;
          line-height: 1.5;
        }

        .trips-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 32px;
        }

        .trip-card-wrapper {
          background: ${color.white};
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
          transition: all 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          padding: 16px;
        }

        .trip-card-wrapper:hover {
          transform: translateY(-6px);
          box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
        }

        .cta-container {
          display: flex;
          justify-content: center;
          margin-top: 48px;
        }

        @media ${breakpoints.medium} {
          .trips-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media ${breakpoints.large} {
          .trips-grid {
            grid-template-columns: repeat(3, 1fr);
          }
        }
      `}</style>
    </div>
  );
};

function pluginKey(index: number) {
  return `trip-${index}`;
}

export default TripsGrid;
